(function(){
    'use strict'

    angular
    .module('app.puestos')
    .controller('EditarPuesto', EditarPuesto);

    EditarPuesto.$inject = ['$scope', '$animationsSrv', '$routeParams','PuestosService', 'logger', '$location'];

    function EditarPuesto($scope, $animationsSrv, $routeParams, PuestosService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.centrosCosto = [];

        vm.puestoId = $routeParams.id ? $routeParams.id : 0;

        getPuesto();

        function getPuesto(){

            if(vm.puestoId != 0){
                var promise = PuestosService.getById(vm.puestoId);

                promise
                .then(function(puesto){
                    vm.puesto = puesto;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el puesto: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.puestoForm.$valid){
                if(!vm.puesto.id){
                    savePuesto();
                }
                else if($scope.puestoForm.$dirty){
                    updatePuesto();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function savePuesto() {
            var promise = PuestosService.save(vm.puesto);
            
            promise
            .then(function(response){
                logger.success('Puesto creado con éxito.');
                clearPuestoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el puesto: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updatePuesto(){
            var promise = PuestosService.update(vm.puesto);
            
            promise
            .then(function(response){
                logger.success('Puesto modificado con éxito.');
                $location.path('/puestos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el puesto: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearPuestoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.puesto = {};
            // Set back to pristine.
            $scope.puestoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.puestoForm.$setUntouched();
        };

    }
})();